import React from 'react'
import SALink from 'components/SALink'
import { Dimensions } from 'components/MeasurementUnit'
import ProductInfoConnector, {
  ConnectorProps as ProductInfoProps,
} from '../../connectors/ProductsArtworkInfo'
import { getTitleCategory } from '../../helpers'
import { OPEN_EDITION, LIMITED_EDITION } from '../../helpers/constants'
import { capitalizeString } from 'lib/helpers'
import classNames from 'classnames'

const ArtworkInfo = (
  props: ProductInfoProps
): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    artistName,
    category,
    country,
    dimensions,
    isAple,
    profileUrl,
    showInfo,
    title,
    unitsProduced,
    currentTab,
    mediums,
    materials,
    isOutdoor
  } = props
  const subtitled = !!title.match(/(limited|edition)/i)
  const limitedSubtitle =
    isAple && unitsProduced && unitsProduced > 0 && !subtitled
      ? `- Limited Edition of ${unitsProduced}`
      : ''
  const capitalizedArtistName = capitalizeString(artistName)

  return (
    <>
      <div data-type='main-artwork-info-container'>
        {currentTab === OPEN_EDITION || currentTab === LIMITED_EDITION ? (
          <h1
            className={classNames('defaultTypographyH4', 'defaultTextBold')}
            data-type='title-text'
            style={{ margin: 0 }}
          >
            {title} Print {limitedSubtitle}
          </h1>
        ) : (
          <h1
            className={classNames('defaultTypographyH4', 'defaultTextBold')}
            data-type='title-text'
            style={{ margin: 0 }}
          >
            {title} {getTitleCategory(category, isOutdoor)} {limitedSubtitle}
          </h1>
        )}

        <SALink data-type='profile' {...{ href: profileUrl, title: capitalizedArtistName }}>
          <p className='defaultTypographyMedium' data-type='profile-artist-name'>
            {capitalizedArtistName}
          </p>
        </SALink>

        <p className='defaultTypographyMedium' data-type='country'>
          {country}
        </p>
      </div>

      {showInfo && (
        <>
          <p className='defaultTypographyMedium'>
            {`${category}, ${mediums.length && mediums[0]} on ${materials.length && materials[0]}`}
          </p>

          <p className='defaultTypographyMedium' style={{ margin: '8px 0px' }}>
            Size: <Dimensions dimensions={dimensions} />
          </p>
        </>
      )}
    </>
  )
}

export default ProductInfoConnector(ArtworkInfo)
